import {Instance, types} from 'mobx-state-tree';

export const Announcement = types.model('Announcement', {
    html: types.string,
    markdown: types.string,
    timestamp: types.string,
});

export interface AnnouncementType extends Instance<typeof Announcement> {}
